import { FC } from 'react'
import { EmptyCardBlockWithCta } from 'components/features/pfm/Blocks/Blocks'
import { LinkAccountHandler } from 'components/features/pfm/LinkAccountHandler/LinkAccountHandler'
import Button from 'components/features/pfm/Button/Button'

type NoAccountsCardProps = {

}

export const NoAccountsCard: FC<NoAccountsCardProps> = (props) => {
  const { children } = props

  const textChild = children || 'See all your accounts in one place.'

  const buttonChild = (
    <LinkAccountHandler>
      <Button style='hollow' fullWidth fullHeight>
        Link your accounts to get started
      </Button>
    </LinkAccountHandler>
  )

  return (
    <EmptyCardBlockWithCta
      text={ textChild }
      button={ buttonChild }
    />
  )
}
